/* Glam Touch — carrito global: agregar rápido, barra de avance al pedido mínimo, carrito lateral y aviso. */
(function () {
  if (window.GT) return;
  var root = document.querySelector('[data-gt-cart-root]');
  var MIN = root ? parseInt(root.dataset.gtMin, 10) || 25000000 : 25000000;
  var numFmt = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
  function money(c) { return '$' + numFmt.format(Math.round(c / 100)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var drawer = document.getElementById('gt-drawer');
  var overlay = document.getElementById('gt-drawer-overlay');
  var toast = document.getElementById('gt-toast');
  var toastTimer = null;
  var lastFocus = null;

  var GT = {
    min: MIN,
    cart: null,
    money: money,

    setCart: function (cart) {
      GT.cart = cart;
      GT.render();
      document.dispatchEvent(new CustomEvent('gt:cart', { detail: cart }));
    },

    refresh: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { GT.setCart(cart); return cart; });
    },

    add: function (id, qty, title) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return GT.refresh(); })
        .then(function (cart) {
          GT.toast(title, cart);
          document.dispatchEvent(new CustomEvent('gt:added', { detail: cart }));
          return cart;
        });
    },

    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { GT.setCart(cart); return cart; });
    },

    progressText: function (total) {
      if (total >= MIN) return '<strong>Tu pedido va en ' + money(total) + '</strong> · ya cumple el mínimo y tiene envío gratis';
      return 'Tu pedido va en <strong>' + money(total) + '</strong> · te faltan <strong>' + money(MIN - total) + '</strong> para el mínimo';
    },

    render: function () {
      var cart = GT.cart;
      if (!cart) return;
      var total = cart.total_price;
      var pct = Math.min(100, Math.round(total * 100 / MIN));

      // Contador del carrito en la cabecera
      document.querySelectorAll('.gt-header__cart').forEach(function (link) {
        var badge = link.querySelector('.gt-header__cart-count');
        if (cart.item_count > 0) {
          if (!badge) { badge = document.createElement('span'); badge.className = 'gt-header__cart-count'; link.appendChild(badge); }
          badge.hidden = false;
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.hidden = true;
        }
      });

      // Barra de avance bajo la cabecera
      document.querySelectorAll('[data-gt-progress]').forEach(function (bar) {
        var wasHidden = bar.hidden;
        bar.hidden = cart.item_count === 0;
        // Evitar que la página salte cuando la barra aparece por primera vez
        if (wasHidden && !bar.hidden && !bar.closest('.gt-drawer')) {
          var h = bar.getBoundingClientRect().height;
          if (h) window.scrollBy(0, h);
        }
        bar.classList.toggle('is-done', total >= MIN);
        var t = bar.querySelector('[data-gt-progress-text]');
        var f = bar.querySelector('[data-gt-progress-fill]');
        if (t) t.innerHTML = GT.progressText(total);
        if (f) f.style.width = pct + '%';
      });

      // Cantidad en cada tarjeta
      var qtyById = {};
      cart.items.forEach(function (it) { qtyById[it.variant_id] = (qtyById[it.variant_id] || 0) + it.quantity; });
      document.querySelectorAll('[data-gt-add]').forEach(function (btn) {
        var q = qtyById[btn.dataset.gtAdd] || 0;
        var badge = btn.querySelector('[data-gt-add-qty]');
        btn.classList.toggle('is-in-cart', q > 0);
        if (badge) { badge.hidden = q === 0; badge.textContent = q; }
      });

      if (drawer && drawer.classList.contains('is-open')) GT.renderDrawer();
    },

    renderDrawer: function () {
      var cart = GT.cart;
      if (!drawer || !cart) return;
      var total = cart.total_price;
      var pct = Math.min(100, Math.round(total * 100 / MIN));
      drawer.querySelector('[data-gt-drawer-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      var prog = drawer.querySelector('[data-gt-drawer-progress]');
      prog.classList.toggle('is-done', total >= MIN);
      prog.querySelector('[data-gt-progress-text]').innerHTML = cart.item_count ? GT.progressText(total) : 'Arma tu pedido desde <strong>' + money(MIN) + '</strong> combinando lo que quieras';
      prog.querySelector('[data-gt-progress-fill]').style.width = pct + '%';

      var list = drawer.querySelector('[data-gt-drawer-items]');
      if (!cart.items.length) {
        list.innerHTML = '<p class="gt-drawer__empty">Tu pedido está vacío.</p>';
      } else {
        list.innerHTML = cart.items.map(function (it) {
          return '<div class="gt-drawer__item">' +
            (it.image ? '<img src="' + esc(img(it.image, 160)) + '" width="64" height="64" alt="" loading="lazy">' : '<span class="gt-drawer__ph"></span>') +
            '<div class="gt-drawer__info">' +
              '<a href="' + esc(it.url) + '" class="gt-drawer__title">' + esc(it.product_title) + '</a>' +
              (it.product_has_only_default_variant ? '' : '<p class="gt-drawer__meta">' + esc(it.variant_title) + '</p>') +
              '<p class="gt-drawer__meta">' + money(it.final_price) + ' c/u</p>' +
              '<div class="gt-drawer__qty">' +
                '<button type="button" data-gt-line="' + esc(it.key) + '" data-gt-line-qty="' + (it.quantity - 1) + '" aria-label="Quitar una unidad">&minus;</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-gt-line="' + esc(it.key) + '" data-gt-line-qty="' + (it.quantity + 1) + '" aria-label="Agregar una unidad">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="gt-drawer__right">' +
              '<strong>' + money(it.final_line_price) + '</strong>' +
              '<button type="button" class="gt-drawer__remove" data-gt-line="' + esc(it.key) + '" data-gt-line-qty="0" aria-label="Quitar ' + esc(it.product_title) + '">Quitar</button>' +
            '</div>' +
          '</div>';
        }).join('');
      }

      drawer.querySelector('[data-gt-drawer-total]').textContent = money(total);
      var box = drawer.querySelector('[data-gt-drawer-box]');
      if (box) box.hidden = total >= MIN;
      var go = drawer.querySelector('[data-gt-drawer-checkout]');
      var lock = drawer.querySelector('[data-gt-drawer-locked]');
      var ok = total >= MIN;
      go.hidden = !ok;
      lock.hidden = ok || !cart.item_count;
      lock.textContent = 'Te faltan ' + money(MIN - total) + ' para pagar';
    },

    open: function () {
      if (!drawer) { window.location.href = '/cart'; return; }
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('gt-no-scroll');
      if (GT.cart) GT.renderDrawer();
      GT.refresh();
      var close = drawer.querySelector('[data-gt-drawer-close]');
      if (close) close.focus();
    },

    close: function () {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      overlay.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('gt-no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    },

    toast: function (title, cart) {
      if (!toast || !cart) return;
      var total = cart.total_price;
      toast.querySelector('[data-gt-toast-text]').innerHTML =
        '<strong>' + esc(title || 'Producto') + '</strong> agregado · ' +
        (total >= MIN ? 'ya cumples el mínimo' : 'te faltan ' + money(MIN - total));
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 250);
      }, 3200);
    }
  };
  window.GT = GT;

  // Agregar rápido desde tarjetas (el botón vive dentro del enlace de la tarjeta)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gt-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    GT.add(btn.dataset.gtAdd, 1, btn.dataset.gtTitle)
      .catch(function (err) {
        alert((err && (err.description || err.message)) || 'No pudimos agregar el producto. Intenta de nuevo.');
      })
      .then(function () { btn.classList.remove('is-loading'); });
  }, true);

  // Abrir el carrito lateral desde la cabecera, la barra de avance y el aviso
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-gt-open-cart], .gt-header__cart');
    if (opener && drawer && window.location.pathname !== '/cart') {
      e.preventDefault();
      GT.open();
      return;
    }
    if (e.target.closest('[data-gt-drawer-close]') || e.target === overlay) { GT.close(); return; }
    var line = e.target.closest('[data-gt-line]');
    if (line) {
      line.disabled = true;
      GT.change(line.dataset.gtLine, Math.max(0, parseInt(line.dataset.gtLineQty, 10) || 0));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) GT.close();
  });

  // En la página del carrito, recargar tras agregar una sugerencia
  document.addEventListener('gt:added', function () {
    if (window.location.pathname === '/cart') window.location.reload();
  });

  // Estado inicial (cantidades en tarjetas y barra)
  if (root && root.dataset.gtCart) {
    try { GT.cart = JSON.parse(root.dataset.gtCart); GT.render(); } catch (err) { GT.refresh(); }
  } else {
    GT.refresh();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) GT.refresh(); });
})();
